import { Skeleton } from "@/components/shared/Skeleton";

export function VocabCardSkeleton() {
  return (
    <div className="relative panel p-5 flex flex-col gap-4">
      {/* Header: Speaker + Word + Part of Speech */}
      <div className="flex items-center gap-2">
        <Skeleton className="w-9 h-9 rounded-full" />
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-4 w-10" />
      </div>

      {/* Definition */}
      <div className="space-y-1.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>

      {/* Image */}
      <Skeleton className="w-full aspect-[4/3] rounded-xl" />

      {/* Example */}
      <div className="space-y-1.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>

      {/* Button */}
      <Skeleton className="h-10 w-full rounded-lg mt-auto" />
    </div>
  );
}
